export function getDashboardBoxes() {
  return [
    {
      key: 'all_products',
      title: 'כל המוצרים',
      icon: '📦',
      path: '/all-products',
    },
    {
      key: 'my_products',
      title: 'המוצרים שלי',
      icon: '🛒',
      path: '/my-products',
    },
    {
      key: 'my_businesses',
      title: 'העסקים שלי',
      icon: '🏪',
      path: '/my-businesses',
    },
    {
      key: 'my_offers',
      title: 'המבצעים שלי',
      icon: '🏷️',
      path: '/my-offers',
    },
    {
      key: 'updates',
      title: 'רשימת עדכונים',
      icon: '🔔',
      path: '/updates',
    },
    {
      key: 'reports',
      title: 'ניתוח ודוחות',
      icon: '📊',
      path: '/reports',
    },
    {
      key: 'test_chat',
      title: 'Test Chat',
      icon: '💬',
      path: '/test-chat',
    },
  ];
}